import React from 'react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { childCare, houseKeeping, nursingCare, right, schoolsupport, seniorCare, servcies, specialNeed } from '../../Constant'

function Services() {
  return (
    <>
    <Header />
    <section className="servcies py-10" 
      style={{ backgroundImage: `url(${servcies})` }} 
        >
    <div className="container hero supplement ">
        <div className="row">
            <div className="col-md-6 py-10">
                <h1 className="white">Service Overview</h1>
                <p className="white">Ensuring your loved ones are safe and happy in their homes.</p>
            </div>
            <div className="col-md-6"></div>
        </div>
    </div>
</section>

<section>
    <div className="container" style={{padding:"40px"}}>
        <div className="row ">

            <div className="col-md-4">
                <h2 className="grey">Would you rather be stay at home or go into an enclosed  
                    <span className="orange">health
                        care facility ?</span></h2>
            </div>
            <div className="col-md-2"></div>
            <div className="col-md-6">

                <p>If you answered "home" to the question, you are no different than rest of us. Most people throughout the world prefer to stay at home and remain in charge of their health while hire others to take care of them. This is exactly what My Home Helper strives to offer when you consult with us - Care with freedom.
                </p>
            </div>


        </div>
    </div>
    <div className="container" style={{padding:"40px"}}>
        <div className="row" id="ads">
            {/* <!-- Category Card --> */}
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={childCare} alt="Alternate Text" />
                    </div>
                    <div className="card-body ">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-10">
                                    <a href="services-details.php" >
                                        <h5 className="grey">Child Care</h5></a>
                                </div>
                            </div>
                            <p>Finding reliable child care providers has never been easier! Browse through our extensive database of licensed and insured child care providers by rate, hours of operation, even read ratings and reviews from other parents just like you. It couldn't be easier to find the perfect match for your family.</p>
                        </div>
                        <a className="ad-btn" href="childcare-service.php"> Read More <i>
                            <img src={right} /></i></a>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={seniorCare} alt="Alternate Text" />
                    </div>
                    <div className="card-body">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-10">
                                    <a href="care-giver.php">
                                        <h5 className="grey">Senior Care</h5>
                                    </a>
                                </div>
                            </div>
                            <p>We make it easy to senior care that fits your needs. We can connect you with the perfect senior care provider in just minutes, whether you're looking for a long-term in-home nurse or for a day. Find top-rated care providers in your neighborhood - along with their background information, rates, and availability, so you can compare different providers in one place.</p>
                        </div>
                        <a className="ad-btn" href="seniorcare-service.php"> Read More <i> <img src={right} /></i></a>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={specialNeed} alt="Alternate Text" />
                    </div>
                    <div className="card-body">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-8"><a href="#">
                                        <h5 className="grey">Special Need</h5>
                                    </a> </div>
                            </div>
                            <p>No need to worry about your special needs child. Find prompt assistance for special education students in attending to their personal, social, and health needs. The range of duties could include personal teacher aide, standing occupations, demonstrations; food preparation, administering medications or treatments; likewise, observing the behavior of the student, and more.</p>
                        </div>
                        <a className="ad-btn" href="specialneed-service.php"> <b>Read More</b> <i>
                        <img src={right} /></i>

                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div className="row py-4" id="ads">
            {/* <!-- Category Card --> */}
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={houseKeeping} alt="Alternate Text" />
                    </div>
                    <div className="card-body">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-10">
                                    <a href="services-details.php">
                                        <h5 className="grey">House Keeping</h5></a>
                                </div>
                            </div>
                            <p>Apart from our careful caregiving services, we provide a complete green cleaning service that is customized to your family's specific needs that include a deep cleaning of the patient's room or the house, as well as weekly cleaning throughout the housekeeping season.</p>
                        </div>
                        <a className="ad-btn" href="housekeeping-service.php"> Read More <i>
                        <img src={right} /></i></a>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={nursingCare} alt="Alternate Text" />
                    </div>
                    <div className="card-body">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-10">
                                    <a href="#">
                                        <h5 className="grey">Nursing Care</h5>
                                    </a>
                                </div>
                            </div>
                            <p>With Physician Home Visits, you are assured of safe, effective, and low-cost delivery of care. Our Physician Home Visits include physician home visits and assessment, changes of surgical wound dressing, administration of antibiotics or medicines, urinary catheterization, monitoring of the vital signs, and more.</p>
                        </div>
                        <a className="ad-btn" href="nursingcare-service.php"> Read More <i>
                        <img src={right} /></i></a>
                    </div>
                </div>
            </div>
            <div className="col-md-4 d-flex align-items-stretch">
                <div className="card rounded card-body1">
                    <div className="card-image">
                        <img className="img-fluid" src={schoolsupport} alt="Alternate Text" />
                    </div>
                    <div className="card-body">
                        <div className="ad-title m-auto">
                            <div className="row">
                                <div className="col-md-8"><a href="#">
                                        <h5 className="grey">School Support</h5>
                                    </a> </div>
                            </div>
                            <p>Your children are in good hands at My Home Helper. Our program is designed to be developmentally appropriate for the age of your child, working hand in hand with you on your child's learning journey. We offer an open-door policy to help better communicate with you on any concerns or issues. Get your child the school support it needs.</p>
                        </div>
                        <a className="ad-btn" href="schoolsupport-service.php"> <b>Read More</b> <i> <img src={right} /></i>

                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
{/* <!-----> */}
<section className="healthy-sec text-center ">
    <div className="container">
        <div className="row text-center py-5">
            <div className="col-md-12">
                <div className="programs ">
                    <h4>Easy to Hire</h4>
                    <h2>Family-Oriented Services</h2>
                </div>
            </div>
        </div>
        <div className="content-wrap ">
            <div className="icon1 ">
                <img src="img/search-icon.png" alt="" height="200"/>
                <div className="programs">
                    <h4>Search Perfect Caregiver</h4>
                    <p className="white">Connect, review, and hire verified caregiver profiles for your personalized needs.</p>
                </div>
            </div>
            <div className="icon1 ">
                <img src="img/pay-icon.png" alt="" height="200"/>
                <div className="programs">
                    <h4>Book and pay online</h4>
                    <p className="white">Review the ratings of the caregiver, book, and pay them online for their services. </p>
                </div>
            </div>
            <div className="icon1">
                <img src="img/smile-icon.png" alt="" height="200"/>
                <div className="programs">
                    <h4>Relax and get satisfied</h4>
                    <p className="white">Rest assured, we are committed to helping you find the right caregiver for your loved ones.</p>
                </div>
            </div>
            {/* <!--<div className="col-md-4">
                <div className="programs">
                    <img src="img/search-icon.png" className="pr-img"/>
                    <h4>Search Perfect Caregiver</h4>
                    <p className="white">Fusce aquam duisvel nibhat velit scelerisque suscipit.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="programs">
                    <img src="img/smile-icon.png" className="pr-img"/>
                    <h4>Book and pay online</h4>
                    <p className="white">Fusce aquam duisvel nibhat velit scelerisque suscipit.</p>
                </div>
            </div>

        <div className="col-md-4">
            <div className="programs">
                <img src="img/pay-icon.png" className="pr-img"/>
                <h4>Relax and get satisfied</h4>
                <p className="white">Fusce aquam duisvel nibhat velit scelerisque suscipit.</p>
            </div>
        </div>--> */}
        </div>
    </div>

</section>
{/* <!--Testimonial--> */}
<section className="testimonial">
    <div className="container" style={{padding:"40px"}}>
        <div className="row text-center" >
            <div className="col-md-12">
                <h4 className="grey">Our Customers</h4>
                <h2 className="orange">Our Pride</h2>
            </div>
        </div>
    </div>

    {/* <!--<div className="d-flex align-items-center py-5 mh-100"> <a className="carousel-control-prev text-decoration-none " href="#mycarousel" role="button" data-bs-slide="prev">
        <div className="d-flex flex-column justify-content-center me-2 ms-auto left">PREV<span className="fa fa-arrow-left"></span> </div> <span className="sr-only">Previous</span>
    </a>--> */}
    <div className="container">
        <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">

            <div className="carousel-inner d-flex">
                <div className="carousel-item col-md-12 active">
                    <div className="row">
                        <div className="col-lg-5 pl-0"> 
                        <img src="img/testimonial-1.png" className="d-block w-100" height="450" alt="..." /> </div>
                        <div className="col-lg-7 " >
                            <div className=" d-flex flex-column my-1 px-4 pt-5">
                                <h4 className="name">Becky Moore, NY | USA </h4>
                                <h2 className="head-t grey">Just in love with service. </h2>
                                <div className=" justify-content-center" style={{fontSize:"14px", paddingTop:"10px", paddingBottom:"10px"}}>What a great site! We have been looking for a long time for a caregiver for our elderly father, and it is so hard to find people with the right mix of skills, reliability, and compassion. Thank you for this great service!</div>
                                <div className="rating pt-4"><span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousel-item col-md-12">
                    <div className="row">
                        <div className="col-lg-5 pl-0"> 
                        <img src="img/testimonial-1.png" className="d-block w-100" height="450" alt="..." /> </div>
                        <div className="col-lg-7 " >
                            <div className=" d-flex flex-column my-1 px-4 pt-5">
                                <h4 className="name">Becky Moore, NY | USA </h4>
                                <h2 className="head-t grey">Genuinely great people to work with!</h2>
                                <div className=" justify-content-center" style={{fontSize:"14px", paddingTop:"10px", paddingBottom:"10px"}}>Hi, I wanted to let you know that your service is amazing! I found a Caregiver for my daughter. She’s perfect! Thank you so much.</div>
                                <div className="rating pt-4"><span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="carousel-item col-md-12">
                    <div className="row">
                        <div className="col-lg-5 pl-0"> 
                        <img src="img/testimonial-1.png" className="d-block w-100" height="450" alt="..." /> </div>
                        <div className="col-lg-7 " >
                            <div className=" d-flex flex-column my-1 px-4 pt-5">
                                <h4 className="name">Becky Moore, NY | USA </h4>
                                <h2 className="head-t grey">Definitely My Home Helper!</h2>
                                <div className=" justify-content-center" style={{fontSize:"14px", paddingTop:"10px", paddingBottom:"10px"}}>As a small business owner, I was getting overworked with managing work and taking care of my baby. I needed a trustworthy nanny who could ensure that all the needs of my baby were adequately met. After searching for a while, I came across My home helper, and it’s been a great relief since then. I don’t have to continuously check on my babysitters and worry till I bite all my nails off. They have been a great help, and I can’t recommend them enough. So a Big Thank You to you guys.</div>
                                <div className="rating pt-4"><span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star checked"></span>
                                    <span className="fa fa-star"></span>
                                    <span className="fa fa-star"></span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!--               <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">-->
            <!--                   <span className="carousel-control-prev-icon" aria-hidden="true"></span>-->
            <!--                   <span className="sr-only">Previous</span>-->
            <!--               </a>-->
            <!--               <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">-->
            <!--                   <span className="carousel-control-next-icon" aria-hidden="true"></span>-->
            <!--                   <span className="sr-only">Next</span>-->
            <!--               </a>--> */}
            <ol className="carousel-indicators pl-1">
                <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
            </ol>
        </div>
    </div>
    {/* <!--<a className="carousel-control-next text-decoration-none " href="#mycarousel" role="button" data-bs-slide="next">
    <div className="d-flex flex-column justify-content-center right ms-2 me-auto"> NEXT <span className="fa fa-arrow-right"></span> </div> <span className="sr-only">Next</span>
</a>--> */}
    
</section>
{/* 
<!--    <section className="py-5 client-logo text-center border-bottom border-top container">-->
<!--        <div className="container ">-->
<!--            <div className="row justify-content-center ">-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-1.png" alt="">-->
<!--                </div>-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-2.png" alt="">-->
<!--                </div>-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-3.png" alt="">-->
<!--                </div>-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-4.png" alt="">-->
<!--                </div>-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-5.png" alt="">-->
<!--                </div>-->
<!--                <div className="col-md-2 col-lg-2 ">-->
<!--                    <img src="img/client-logo-6.png" alt="">-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--         end of .container-->
<!--    </section>--> */}
    <section className="py-1 client-logo text-center border-bottom border-top container">
        <div className="container">
            <section className="customer-logos-services slider-client">
                <div className="slide"><img src="img/client-logo-1.png" /></div>
                <div className="slide"><img src="img/client-logo-2.png" /></div>
                <div className="slide"><img src="img/client-logo-3.png" /></div>
                <div className="slide"><img src="img/client-logo-4.png" /></div>
                <div className="slide"><img src="img/client-logo-5.png" /></div>
                <div className="slide"><img src="img/client-logo-2.png" /></div>
                <div className="slide"><img src="img/client-logo-6.png" /></div>
                <div className="slide"><img src="img/client-logo-1.png" /></div>
                <div className="slide"><img src="img/client-logo-4.png" /></div>
            </section>
        </div>
    </section>
    <Footer />
    </>
  )
}

export default Services